// src/utils/auth.js
export function decodeJwt(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

export function isAdminFromAccess() {
  const token = sessionStorage.getItem("access");
  if (!token) {
    return false;
  }

  const payload = decodeJwt(token);

  return Boolean(payload?.is_superuser);
}
export function isAccessTokenValid() {
  const token = sessionStorage.getItem("access");
  if (!token) return false;

  const p = decodeJwt(token);
  if (!p?.exp) return false;

  // exp este în secunde
  return Date.now() < p.exp * 1000;
}